import {useEffect} from 'react'
import {preventBodyScroll} from '@zag-js/remove-scroll'

/**
 * Locks native body scroll while `lock` is true (Chakra v3 / Zag
 * `preventBodyScroll`). Used by the Xleap navigation header — the one open
 * surface that isn't a Chakra overlay (overlays lock the body themselves and
 * pair with `useLenisScrollLock`).
 *
 * @param {boolean} [lock] - whether native body scroll should be locked
 * @example
 * useNativeScrollLock(isOpen)
 */
function useNativeScrollLock(lock) {
    useEffect(() => {
        if (!lock || typeof document === 'undefined') return undefined
        return preventBodyScroll(document)
    }, [lock])
}

export default useNativeScrollLock
